import React from 'react';
import { Link } from 'react-router-dom';
import { useSavedArtworks } from '../../context/SavedArtworksContext';

const getArtworkImage = (artwork) => {
  if (artwork.image) return artwork.image;
  if (artwork.imageData && artwork.imageMimeType) {
    return `data:${artwork.imageMimeType};base64,${artwork.imageData}`;
  }
  return artwork.imageUrl || null;
};

const SavedArtworksSection = () => {
  const { savedArtworks, loading } = useSavedArtworks();

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mt-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-pink-100 flex items-center justify-center text-pink-600 text-lg">
          ♥
        </div>
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Saved</h2>
          <p className="text-sm text-gray-500">Artworks you have saved from Artozphere</p>
        </div>
      </div>

      {loading ? (
        <p className="text-sm text-gray-500">Loading saved artworks...</p>
      ) : savedArtworks.length === 0 ? (
        <div className="py-12 text-center text-sm text-gray-500">
          No saved artworks yet.{' '}
          <Link to="/artozphere" className="text-blue-600 hover:underline">
            Browse Artozphere
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {savedArtworks.map((artwork) => {
            const image = getArtworkImage(artwork);
            const detailPath = `/artozphere/artwork/${artwork.slug || artwork._id || artwork.id}`;

            return (
              <Link
                key={artwork._id || artwork.id}
                to={detailPath}
                className="group relative aspect-square overflow-hidden rounded-lg bg-gray-100"
              >
                {image ? (
                  <img
                    src={image}
                    alt={artwork.title}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                ) : (
                  <div className="flex h-full w-full items-center justify-center text-xs text-gray-400">
                    No image
                  </div>
                )}
                <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 transition-opacity group-hover:opacity-100">
                  <span className="px-2 text-center text-xs font-medium text-white">
                    {artwork.title}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SavedArtworksSection;
